/******************************************** carousel slide  ***************************************************/
document.addEventListener('DOMContentLoaded', init)

function init() {
  document.querySelectorAll('.wp-block-webdevia-carousel').forEach(carouselBlock => {
    const options = JSON.parse(carouselBlock.dataset.options);
    const nextButton = carouselBlock.querySelector('.swiper-button-next');
    const prevButton = carouselBlock.querySelector('.swiper-button-prev');
    if (nextButton && prevButton) {
      options.navigation = { nextEl: nextButton, prevEl: prevButton };
    }
    new Swiper(carouselBlock, options);
  });
}
